module.exports = __webpack_public_path__ + "static/undraw_time_management_30iu-7873ea8f50a2ccc36783be2412a3d43d.svg";